<template>
  <div class='class-schedule'>
    <div v-if='(!isEditAction || action) && class_detail.length' class='title'>
      （{{ startEndTime[0] | date }} 至<span v-if='is_pause'>-</span><span v-else>{{ startEndTime[1] | date }}</span>)
      <template v-if='action && !isClassEnd'>
        <template v-if='actionEdit'>
          <el-button type='primary' size='mini' @click='saveSc'>保存</el-button>
          <el-button size='mini' @click='cancelEdit'>还原</el-button>
        </template>
        <el-button type='primary' size='mini' v-else @click='actionEdit = !actionEdit'>编辑</el-button>
      </template>
    </div>
    <ly-calendar v-loading='loading' v-model='calendarValue' key='calendar_diy'>
      <template slot='dateCell' slot-scope='{ date, data }'>
        <div @click='openDgInner(data.day, date)' class='day' :class='isDisable(data.day)'>
          <div class='now'>
            <div>
              {{ date.getDate() }}
            </div>
            <div class='ly-holiday'>{{ getHoliday(data.day) }}</div>
          </div>
          <div class='class-info-box' v-if='calendarData[data.day] && calendarData[data.day].length'>
            <div class='class-info' v-for='item in calendarData[data.day]'>
              <div class='class-info-left'>
                <div class='class-time'>
                  {{ item.class_begin_time }} -
                  {{ item.class_end_time }}
                </div>
                <div class='class-room'>{{ item.class_room_name }}</div>
              </div>
              <div class='class-teacher'>
                {{ item.teacher_name }}
                <span style='color:#f56c6c' v-if='item.teacher_type === 3'>(代)</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ly-calendar>
    <el-dialog width='500px' title='请输入课程信息' :visible.sync='innerVisible' append-to-body>
      <el-form size='small' class='diy-class-detail' :model='calenderForm' ref='calenderForm' label-width='80px'>
        <div class='form-list' v-for='(item, index) in calenderForm.list' :key='item.key'>
          <el-divider v-if='index > 0' />
          <div class='form-del' v-if="item.tab === 'one'">
            <el-button @click='del(item)' type='danger'>删除</el-button>
          </div>
          <el-form-item label='上课日期' :prop="'list.' + index + '.date'" :rules='calenderRules.date'>
            <el-radio-group @change='changeDayMode(index)' v-model='item.tab' class='m-b-15'>
              <el-radio-button label='one'>单天</el-radio-button>
              <el-radio-button label='mul'>连续</el-radio-button>
            </el-radio-group>
            <br />
            <el-date-picker v-model='item.date' v-show="item.tab === 'one'" type='date' placeholder='选择日期'
              @change='restRoomAndTeacher(index)' :picker-options='{
                disabledDate(time) {
                  return time.getTime() < Date.now() - 8.64e7;
                }
              }'>
            </el-date-picker>
            <el-date-picker v-model='item.date' v-show="item.tab === 'mul'" @change='restRoomAndTeacher(index)'
              type='daterange' placeholder='选择日期' :picker-options='{
                disabledDate(time) {
                  return time.getTime() < Date.now() - 8.64e7;
                }
              }'>
            </el-date-picker>
          </el-form-item>
          <el-form-item label='上课时间' :prop="'list.' + index + '.class_time'" :rules='calenderRules.class_time'>
            <el-time-picker is-range arrow-control v-model='item.class_time' range-separator='至' start-placeholder='开始时间'
              end-placeholder='结束时间' placeholder='选择时间范围' value-format='HH:mm' @change='resetRoom(index)' format='HH:mm'
              :selectableRange="['09:30 - 12:00', '14:30 - 18:30']"></el-time-picker>
          </el-form-item>
          <el-form-item label='教室' :prop="'list.' + index + '.class_room_id'" :rules='calenderRules.class_room_id'>
            <remote-search :defaultData='defaultData[index]' ref='class_room_id' :options='class_room_id'
              :paramsData='paramsData(index)' @input='(value, label) => tempRoomhandleChange(value, label, index)'
              :isCache='true' />
          </el-form-item>
          <el-form-item label='任课老师' :prop="'list.' + index + '.teacher_id'" :rules='calenderRules.teacher_id'>
            <remote-search :defaultData='defaultTeacherData[index]' ref='teacher_id' :options='teacher_id'
              :paramsData='paramsData(index)' @input='(value, label) => tempTeacherhandleChange(value, label, index)'
              :isCache='true' />
          </el-form-item>
        </div>
        <div class='form-add-btn'>
          <el-button @click='addFormItem'>新增</el-button>
        </div>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='close'>取 消</el-button>
        <!--                <el-button @click='del' type='danger' v-show="calendarData[curCalender] && tabType === 'one'">删除</el-button>-->
        <el-button type='primary' @click='setCalenderData'>添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { DatePicker, Dialog, Divider, Form, FormItem, RadioButton, RadioGroup, TimePicker } from 'element-ui';
import dayjs from 'dayjs';
import RemoteSearch from '@/components/common/RemoteSearch';
import { class_room_id, teacher_ids } from '@/utils/formConfigCommon';
import utils from '@/utils';
import { classApi } from '@/api';
import LyCalendar from './LyCalendar';

const defaultCalenderForm = {
  class_time: '',
  class_room_id: '',
  class_room_name: '',
  date: '',
  teacher_id: '',
  teacher_name: '',
  tab: 'one',
  key: Date.now()
};
export default {
  name: 'ClassSchedule',
  components: {
    LyCalendar,
    ElDialog: Dialog,
    RemoteSearch,
    ElForm: Form,
    ElFormItem: FormItem,
    ElTimePicker: TimePicker,
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    ElDatePicker: DatePicker,
    ElDivider: Divider
  },
  props: {
    class_mode: {
      type: Number
    },
    // 课程表仅展示 or 可编辑
    isEdit: {
      type: Boolean,
      default: () => false
    },
    action: {
      type: Boolean,
      default: () => false
    },
    isCopy: {
      type: Boolean,
      default: () => false
    },
    class_id: {
      type: Number,
      default: () => 0
    },
    courseLen: {
      type: Number,
      default: () => 0
    }
  },
  watch: {
    class_id() {
      // 设置默认值
      this.cancelEdit();
      this.actionEdit = false;
      this.isEditConfim = false;
    }
  },
  data() {
    return {
      isHoliday: true,
      // tabType: 'one',
      loading: false,
      defaultData: [],
      defaultTeacherData: [],
      class_room_id: {
        ...class_room_id.options,
        key: 'class_room_id'
      },
      teacher_id: {
        ...teacher_ids.options,
        key: 'teacher_id',
        multiple: false
      },
      calendarData: {}, // 自定义课表数据 key: date, value: 课
      innerVisible: false,
      curCalender: '',
      calenderForm: {
        list: [{ ...defaultCalenderForm, key: Date.now() }]
      },
      calenderRules: {
        class_time: [{ required: true, message: '请先选择上课时间段', trigger: 'change' }],
        date: [{ required: true, message: '请先选择上课日期', trigger: 'change' }],
        class_room_id: [{ required: true, message: '请选择上课教室', trigger: 'blur' }],
        teacher_id: [{ required: true, message: '请选择任课老师', trigger: 'blur' }]
      },
      class_detail: [], // 课表数组，后端保存的数据
      calendarValue: '',
      holidayDate: [],
      holidayDateQuery: [],
      holidayDateMap: {},
      actionEdit: false,
      isEditConfim: false,
      isClassEnd: false,
      assistantTeacher: [], // 助教老师
      changeMessage: false,
      is_pause: false
    };
  },
  computed: {
    startEndTime() {
      if (this.class_detail.length && (!this.isEditAction || this.action)) {
        const res = [];
        const allTime = this.class_detail.map(item => dayjs(item.class_start_time).valueOf());
        allTime.sort();
        res[0] = dayjs(allTime[0]).format('YYYY-MM-DD');
        res[1] = dayjs(allTime[allTime.length - 1]).format('YYYY-MM-DD');
        return res;
      }
      return [];
    },
    paramsData() {
      // eslint-disable-next-line no-unused-expressions
      this.calenderForm;
      // eslint-disable-next-line no-unused-expressions
      this.class_mode;
      return index => {
        const { tab } = this.calenderForm.list[index];
        if (this.calenderForm.list[index].class_time && this.calenderForm.list[index].class_time.length) {
          const { date } = this.calenderForm.list[index];
          if (tab === 'one' && !date) {
            return {
              class_detail: null
            };
          }
          if (tab === 'mul' && (!date || date.length !== 2 || !date[0] || !date[1])) {
            return {
              class_detail: null
            };
          }
          const [class_begin_time, class_end_time] = this.calenderForm.list[index].class_time;
          if (tab === 'one') {
            return utils.getClassDetail({
              class_start_date: dayjs(date).format('YYYY-MM-DD'),
              class_begin_time,
              class_end_time,
              class_mode: this.class_mode
            });
          }
          return utils.getClassDetail({
            class_start_date: dayjs(date[0]).format('YYYY-MM-DD'),
            class_end_date: dayjs(date[1]).format('YYYY-MM-DD'),
            class_begin_time,
            class_end_time,
            class_mode: 1
          });
        }
        return {
          class_detail: null
        };
      };
    },
    isDisable() {
      return day => {
        if (this.isEdit) {
          return new Date().getTime() > new Date(`${day} 23:59:59`).getTime() ? 'disable' : '';
        }
        if (!this.actionEdit) return 'cursor-init';
        return '';
      };
    },
    getHoliday() {
      let temp = [];
      let num = 0;
      const that = this;
      return day => {
        if (num === 0) temp[0] = day;
        num += 1;
        if (that.holidayDate.length) {
          if (that.holidayDate.includes(day)) return '休';
          if (num === 0 && that.holidayDateQuery[0] !== day) that.holidayDate = [];
        }
        if (num % 42 === 0) {
          temp[1] = day;
          that.queryHoliday(temp);
          num = 0;
          temp = [];
        }
        return '';
      };
    },
    isEditAction() {
      return this.isEdit || this.actionEdit;
    }
  },
  mounted() {
    this.init();
  },
  filters: {
    date(value) {
      return dayjs(value).format('YYYY-MM-DD');
    }
  },
  methods: {
    addFormItem() {
      this.calenderForm.list.push({ ...defaultCalenderForm, key: Date.now(), date: this.curCalender });
    },
    cancelEdit() {
      this.actionEdit = !this.actionEdit;
      this.init();
    },
    async init() {
      if (!this.class_id) {
        this.reset();
        return;
      }
      this.loading = true;
      const tmp = {};
      this.class_detail = [];
      const result = await this.getClassDetailById();
      if (!result.length) {
        this.loading = false;
        return;
      }
      if (new Date().getTime() > new Date(`${result[result.length - 1].class_start_time}`).getTime()) {
        // 已结课
        this.isClassEnd = true;
        this.changeMessage = false;
        // } else if (new Date(`${result[0].class_start_time}`).getTime() < new Date().getTime() && new Date(`${result[result.length - 1].class_start_time}`).getTime() > new Date().getTime()) {
        //   console.log('kk');
        //   // 已开课
        //   this.isClassEnd = true;
        //   this.changeMessage = true;
        // } else {
        this.isClassEnd = false;
        this.changeMessage = false;
      }
      result.map(item => {
        const mBegin = dayjs(item.class_start_time);
        const mEnd = dayjs(item.class_end_time);
        const key = mBegin.format('YYYY-MM-DD');
        tmp[key] = [...(tmp.hasOwnProperty(key) ? tmp[key] : []), {
          class_begin_time: mBegin.format('HH:mm'),
          class_end_time: mEnd.format('HH:mm'),
          class_room_id: item.class_room_id,
          class_room_name: item.name,
          teacher_name: item.teacher_name,
          id: item.id,
          teacher_id: item.teacher_id,
          teacher_type: item.teacher_type,
          course_periodic: item.course_periodic
        }];
        return item;
      });
      this.calendarData = tmp;
      this.loading = false;

      if (this.isEditAction) {
        this.calendarValue = '';
      } else {
        this.calendarValue = this.class_detail.length ? this.class_detail[0].class_start_time : '';
      }
    },
    async getClassDetailById() {
      // if (this.class_detail.length) return this.class_detail;
      classApi.controlClass({ id: this.class_id }).then(res => {
        if (res.data) {
          this.is_pause = res.data.class_info.is_pause;
        }
        if (res.data && res.data.class_info.teacher) {
          this.assistantTeacher = res.data.class_info.teacher
            .filter(item => item.teacher_type === 2)
            .map(item => ({ teacher_id: item.id, teacher_type: item.teacher_type }));
        }
      });
      if (!this.class_id) return [];
      const res = await classApi.getClassSchedule({
        id: this.class_id
      });

      if (res && res.data) {
        this.class_detail = Object.freeze(res.data.list);
        return res.data.list;
      }
      return [];
    },
    tempRoomhandleChange(value, label, index) {
      this.calenderForm.list[index].class_room_id = value;
      this.calenderForm.list[index].class_room_name = label;
    },
    tempTeacherhandleChange(value, label, index) {
      this.calenderForm.list[index].teacher_id = value;
      this.calenderForm.list[index].teacher_name = label;
      this.calenderForm.list[index].teacher_type = 1;
    },
    close() {
      this.calenderForm.list = [{ ...defaultCalenderForm, key: Date.now() }];
      this.innerVisible = false;
    },
    reset() {
      this.defaultData = [];
      /* this.calenderForm.class_room_id = '';
      this.calenderForm.class_time = ''; */
      this.calenderForm.list.forEach(item => {
        item.class_room_id = '';
        item.class_time = '';
      });
      this.class_detail = [];
      this.calendarData = {};
    },
    restRoomAndTeacher(index) {
      this.$refs.teacher_id[index].clear();
      this.$refs.class_room_id[index].clear();
    },
    openDgInner(day) {
      this.$emit('click', day);
      if (!this.isEditAction) return;
      this.innerVisible = true;
      this.curCalender = day;
      // this.calenderForm.date = day;
      if (this.calendarData[day] && this.calendarData[day].length) {
        // this.calenderForm.id = this.calendarData[day].id;
        /* this.defaultData = {
           options: [
             {
               id: this.calendarData[day].class_room_id,
               name: this.calendarData[day].class_room_name
             }
           ],
           value: this.calendarData[day].class_room_id
         }; */
        this.defaultData = this.calendarData[day].map(item => ({
          options: [
            {
              id: item.class_room_id,
              name: item.class_room_name
            }
          ],
          value: item.class_room_id
        }));
        this.calenderForm.list = this.calendarData[day].map(item => ({
          class_room_id: item.class_room_id,
          class_time: [item.class_begin_time, item.class_end_time],
          tab: 'one',
          date: day,
          id: item.id,
          key: item.key
        }));
        this.defaultTeacherData = this.calendarData[day].map(item => ({
          options: [
            {
              id: item.teacher_id,
              real_name: item.teacher_name
            }
          ],
          value: item.teacher_id
        }));
        // this.calenderForm.class_room_id = this.calendarData[day].class_room_id;
        // this.calenderForm.class_time = [this.calendarData[day].class_begin_time, this.calendarData[day].class_end_time];
        // if (this.calendarData[day].teacher_id) {
        //   this.defaultTeacherData = {
        //     options: [
        //       {
        //         id: this.calendarData[day].teacher_id,
        //         real_name: this.calendarData[day].teacher_name
        //       }
        //     ],
        //     value: this.calendarData[day].teacher_id
        //   };
        // }
      } else {
        this.calenderForm.list = [{ ...defaultCalenderForm, key: Date.now(), date: day }];
        setTimeout(() => {
          if (this.$refs.class_room_id) {
            this.$refs.class_room_id.forEach((item, i) => {
              this.$refs.class_room_id[i].clear();
            });
          }
          if (this.$refs.teacher_id) {
            this.$refs.teacher_id.forEach((item, i) => {
              this.$refs.teacher_id[i].clear();
            });
          }
        }, 10);
      }
    },
    resetRoom(index) {
      this.calenderForm.list[index].class_room_id = '';
      this.$refs.class_room_id[index].clear();
      this.calenderForm.list[index].teacher_id = '';
      this.$refs.teacher_id[index].clear();
    },
    setCalenderData() {
      this.$refs.calenderForm.validate(valid => {
        if (valid) {
          const temp = {};
          this.calenderForm.list.forEach(calenderFormItem => {
            const [class_begin_time, class_end_time] = calenderFormItem.class_time;
            const { date, tab } = calenderFormItem;
            let details;
            if (tab === 'one') {
              details = utils.getClassDetail({
                class_start_date: dayjs(date).format('YYYY-MM-DD'),
                class_begin_time,
                class_end_time,
                class_mode: this.class_mode
              });
            } else {
              details = utils.getClassDetail({
                class_start_date: dayjs(date[0]).format('YYYY-MM-DD'),
                class_end_date: dayjs(date[1]).format('YYYY-MM-DD'),
                class_begin_time,
                class_end_time,
                class_mode: 1
              });
            }
            if (details.class_detail) {
              details.class_detail.map(item => {
                const key = dayjs(item.class_start_time).format('YYYY-MM-DD');
                temp[key] = [...(temp.hasOwnProperty(key) ? temp[key] : []), {
                  class_begin_time,
                  class_end_time,
                  class_room_id: calenderFormItem.class_room_id,
                  class_room_name: calenderFormItem.class_room_name,
                  teacher_id: calenderFormItem.teacher_id,
                  id: calenderFormItem.id,
                  teacher_name: calenderFormItem.teacher_name,
                  teacher_type: calenderFormItem.teacher_type,
                  key: calenderFormItem.key

                }];
                return item;
              });
            }
          });
          /* 判断交集 */
          const currentObj = [];
          const otherArr = {};
          Object.keys(temp).forEach(item => {
            if (this.curCalender === item) {
              temp[item].forEach(tempItem => {
                currentObj.push({
                  s: tempItem.class_begin_time,
                  e: tempItem.class_end_time
                });
                // currentObj.start.push(new Date(`${item} ${tempItem.class_begin_time}:00`).getTime());
                // currentObj.end.push(new Date(`${item} ${tempItem.class_end_time}:00`).getTime());
              });
              // currentObj[item] = temp[item];
            } else {
              temp[item].forEach(tempItem => {
                otherArr[item] = [];
                otherArr[item].push({
                  s: tempItem.class_begin_time,
                  e: tempItem.class_end_time
                });
                /* const otherCur = { start: [], end: [] };
                 otherCur.start.push(new Date(`${item} ${tempItem.class_begin_time}:00`).getTime());
                 otherCur.end.push(new Date(`${item} ${tempItem.class_end_time}:00`).getTime());
                 otherArr.push(otherCur); */
              });
              if (Object.keys(this.calendarData).includes(item)) {
                this.calendarData[item].forEach(tempItem => {
                  otherArr[item].push({
                    s: tempItem.class_begin_time,
                    e: tempItem.class_end_time
                  });
                });
              }
            }
          });
          let isRepeat = false;
          if (currentObj.length && currentObj.length > 1) {
            for (const k in currentObj) {
              if (!this.judege(k, currentObj)) {
                isRepeat = true;
              }
            }
          }
          if (Object.keys(otherArr).length) {
            Object.keys(otherArr).forEach(item => {
              for (const k in otherArr[item]) {
                if (!this.judege(k, otherArr[item])) {
                  isRepeat = true;
                }
              }
            });
          }
          if (isRepeat) {
            this.$message.error('上课时间存在交集');
            return;
          }
          Object.keys(temp).forEach(item => {
            if (Object.keys(this.calendarData).includes(item)) {
              // this.calendarData[item].push(...temp[item]);
              this.calendarData = Object.freeze({
                ...this.calendarData,
                [item]: this.curCalender !== item ? [
                  ...this.calendarData[item],
                  ...temp[item]
                ] : [
                  ...temp[item]
                ]
              });
            } else {
              // this.calendarData[item] = temp[item];
              this.calendarData = Object.freeze({
                ...this.calendarData,
                [item]: temp[item]
              });
            }
          });
          // this.calendarData = Object.freeze({
          //   ...this.calendarData,
          //   ...temp
          // });
          console.info('setCalenderData:this.calendarData:', this.calendarData);
          // return;
          this.innerVisible = false;
          // this.$emit('input', this.getClassDetail());
          this.toEmitInput();
          this.calenderForm.list = [{ ...defaultCalenderForm, key: Date.now() }];
          this.isEditConfim = true;
        }
      });
    },
    judege(idx, dateAr) {
      // eslint-disable-next-line no-restricted-syntax
      for (const k in dateAr) {
        if (idx !== k) {
          if (dateAr[k].s <= dateAr[idx].s && dateAr[k].e > dateAr[idx].s) {
            return false;
          }
          if (dateAr[k].s < dateAr[idx].e && dateAr[k].e >= dateAr[idx].e) {
            return false;
          }
        }
      }
      return true;
    },
    delAll() {
      const tmp = { ...this.calendarData };
      delete tmp[this.curCalender];
      this.calendarData = tmp;
      this.innerVisible = false;
      // this.$emit('input', this.getClassDetail());
      this.toEmitInput();
    },
    del(values) {
      if (values.hasOwnProperty('id') && values.id) {
        this.calenderForm.list = this.calenderForm.list.filter(item => {
          if (!item.id) {
            return true;
          }
          return item.id !== values.id;
        });
        this.calendarData = Object.freeze({
          ...this.calendarData,
          [this.curCalender]: this.calendarData[this.curCalender].filter(item => {
            if (!item.id) {
              return true;
            }
            return item.id !== values.id;
          })
        });
        /*  this.calendarData[this.curCalender] = this.calendarData[this.curCalender].filter(item => {
            if (!item.id) {
              return true;
            }
            return item.id !== values.id;
          }); */
      } else if (values.hasOwnProperty('key') && values.key) {
        this.calenderForm.list = this.calenderForm.list.filter(item => {
          if (!item.key) {
            return true;
          }
          return item.key !== values.key;
        });
        if (this.calendarData[this.curCalender] && this.calendarData[this.curCalender].length) {
          this.calendarData = Object.freeze({
            ...this.calendarData,
            [this.curCalender]: this.calendarData[this.curCalender].filter(item => {
              if (!item.key) {
                return true;
              }
              return item.key !== values.key;
            })
          });
        }
      }
      // const tmp = { ...this.calendarData };
      // delete tmp[this.curCalender];
      // this.calendarData = tmp;
      if (!this.calenderForm.length) {
        this.innerVisible = false;
      }
      // this.$emit('input', this.getClassDetail());
      this.toEmitInput();
    },
    toEmitInput() {
      const class_detail = this.getClassDetail();
      this.$emit('input', class_detail, [
        ...[...new Set(class_detail.map(item => item.teacher_id))].map(id => ({ teacher_id: id, teacher_type: 1 })),
        ...this.assistantTeacher
      ]);
    },
    getClassDetail() {
      const res = [];
      // 注意生成的课程表必须有序，否则难以找到课程开始、结束日期
      Object.keys(this.calendarData)
        .map(item => new Date(item).getTime())
        .sort((a, b) => a - b)
        .forEach(date => {
          const day = dayjs(date).format('YYYY-MM-DD');
          this.calendarData[day].forEach(item => {
            res.push({
              class_start_time: `${day} ${item.class_begin_time}:00`,
              class_end_time: `${day} ${item.class_end_time}:00`,
              course_periodic: new Date(date).getDay(),
              id: item.id,
              class_room_id: item.class_room_id,
              teacher_id: item.teacher_id,
              teacher_name: item.teacher_name,
              teacher_type: item.teacher_type
            });
          });
        });
      return res;
    },
    queryHoliday(temp) {
      if (this.holidayDateQuery.length && this.holidayDateQuery[0] === temp[0] && this.holidayDateQuery[1] === temp[1]) return;
      if (this.holidayDateMap[`${temp[0]}${temp[1]}`]) {
        this.holidayDateQuery = [...temp];
        this.holidayDate = [...this.holidayDateMap[`${temp[0]}${temp[1]}`]];
        return;
      }
      classApi
        .holidayList({
          params: {
            start_date: temp[0],
            end_date: temp[1]
          }
        })
        .then(res => {
          if (res && res.data) {
            const tempDate = [];
            res.data.holiday_list.map(item => {
              const start = dayjs(item.start_date).format('YYYY-MM-DD');
              const end = dayjs(item.end_date).format('YYYY-MM-DD');
              const len = dayjs(end).diff(dayjs(start), 'day');
              for (let index = 0; index < len + 1; index += 1) {
                tempDate.push(
                  dayjs(start)
                    .add(index, 'day')
                    .format('YYYY-MM-DD')
                );
              }
              return item;
            });
            this.holidayDateMap = {
              ...this.holidayDateMap,
              [`${temp[0]}${temp[1]}`]: [...tempDate]
            };
            this.holidayDateQuery = [...temp];
            this.holidayDate = [...tempDate];
          }
        });
    },
    saveSc() {
      const class_detail = this.getClassDetail();
      let class_periodic = [];
      class_detail.every(item => {
        if (class_periodic.length >= 7) return false;
        // const week = dayjs(item.class_start_time).day();
        const week = item.course_periodic;
        if (!class_periodic.includes(week)) class_periodic.push(week);
        return true;
      });
      class_periodic = class_periodic
        .sort((a, b) => a - b)
        .filter(item => item !== '')
        .join(',');
      if (!class_detail || !class_detail.length) {
        this.$message.error('至少需要一个课次');
        return;
      }
      const detail_teacher_ids = [...new Set(class_detail.map(item => item.teacher_id))];
      if (this.courseLen) {
        if (this.courseLen > class_detail.length) {
          this.$message.error(`还剩${this.courseLen - class_detail.length}课次未安排！`);
          return;
        } if (this.courseLen < class_detail.length) {
          this.$message.error('该课程课次已满！');
          return;
        }
      }
      this.loading = true;
      classApi
        .getClassSchedule({
          id: this.class_id,
          params: {
            class_detail,
            class_periodic,
            class_mode: 3,
            teacher_ids: [
              ...detail_teacher_ids.map(id => ({ teacher_id: id, teacher_type: 1 })),
              ...this.assistantTeacher
            ],
            courses_count: class_detail.length
          },
          methold: 'put'
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '更新课表成功！');
            this.$emit('close');
          }
          this.loading = false;
          this.actionEdit = false;
        });
    },
    changeDayMode(index) {
      this.$refs.class_room_id[index].clear();
      if (this.calenderForm.list[index].tab === 'one') {
        if (Array.isArray(this.calenderForm.list[index].date)) [this.calenderForm.list[index].date] = this.calenderForm.list[index].date;
        else this.calenderForm.list[index].date = '';
      } else {
        this.calenderForm.list[index].date = [this.calenderForm.list[index].date || '', ''];
      }
    }
  }
};
</script>

<style lang='less'>
.class-schedule {
  position: relative;

  .el-calendar-table__row>td {
    border: none !important;
    padding: 0 20px;
  }

  .el-calendar-day {
    border-top: 2px solid #E4E9F1;
    cursor: initial;
    height: 138px;
    margin-bottom: 26px;
  }

  .is-today {
    //color: #4caf50;

    .el-calendar-day {
      background-color: rgba(115, 171, 109, 0.08);
      border-color: #73AB6D;

      .now {
        color: #67AD5B;
      }
    }
  }

  .is-selected {
    background: none !important;

    .el-calendar-day {
      background-color: rgba(115, 171, 109, 0.08);

    }
  }

  .title {
    font-size: 14px;
    position: absolute;
    left: 100px;
    top: 4px;
    color: #999;

    .mess-span {
      font-size: 12px;
      margin-left: 10px;
      color: #F56C6C;
    }
  }

  .checked {
    color: #3a8ee6;
  }

  .el-calendar__body {
    padding: 0 0 10px 0;
  }

  .el-calendar__header {
    padding: 0 0 12px 0;
  }

  .el-date-editor .el-range-separator {
    width: 24px;
  }

  .class-info-box {
    height: 93px;
    padding-right: 12px;
    overflow-y: scroll;
  }

  .class-info {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    padding-left: 10px;

    &:not(:first-child) {
      margin-top: 16px;
    }

    .class-info-left {
      color: #212121;
      text-align: left;
      max-width: 110px;
    }

    .class-time {
      position: relative;
      margin-bottom: 8px;

      &::before {
        content: '';
        width: 4px;
        height: 4px;
        background: #2793F9;
        opacity: 1;
        position: absolute;
        left: -8px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
      }
    }

    .class-room {
      //overflow: hidden;
      //white-space: nowrap;
      //text-overflow: ellipsis;
    }

    .class-teacher {
      color: #979CA0;
      text-align: right;
    }
  }

  .day {
    height: 100%;
    overflow: hidden;
    position: relative;

    &.disable {

      cursor: not-allowed;

      .now {
        color: #ccc;
      }
    }

    &.cursor-init {
      cursor: initial;
    }

    >.now {
      text-align: right;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC, serif;
      font-weight: 500;
      color: #000;
      line-height: 19px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .ly-holiday {
    color: @danger;
    font-size: 14px;
    margin-left: 10px;
  }
}

.diy-class-detail {
  height: 400px;
  overflow-y: scroll;

  .el-range-separator {
    width: 24px;
  }

  .form-list {
    position: relative;

    .form-del {
      position: absolute;
      right: 10px;
      z-index: 2;
    }
  }
}

.form-add-btn {
  width: 100%;
  text-align: center;
  margin-top: 30px;

  .el-button {
    width: 200px;
  }
}
</style>
